import { Suspense, useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ApiStatusBanner from './ApiStatusBanner';
import CartDrawer from './CartDrawer';
import Footer from './Footer';
import Header from './Header';
import Spinner from './Spinner';
import WhatsAppButton from './WhatsAppButton';

export default function Layout() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const main = useRef(null);
  const lastPath = useRef(pathname);

  // On client-side navigation, reset scroll and move focus to the content so
  // keyboard and screen reader users start at the top of the new page.
  useEffect(() => {
    if (lastPath.current === pathname) return; // initial mount (also under StrictMode)
    lastPath.current = pathname;
    window.scrollTo(0, 0);
    main.current?.focus({ preventScroll: true });
  }, [pathname]);

  const skip = (e) => {
    e.preventDefault(); // keep the URL free of #fragments
    main.current?.focus();
    main.current?.scrollIntoView();
  };

  return (
    <div className="flex min-h-screen flex-col">
      <a
        href="#main"
        onClick={skip}
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-btn focus:bg-primary focus:px-5 focus:py-3 focus:font-semibold focus:text-primary-contrast"
      >
        {t('a11y.skipToContent')}
      </a>
      <Header />
      <ApiStatusBanner />
      <main id="main" ref={main} tabIndex={-1} className="flex-1 outline-none">
        <Suspense
          fallback={
            <div className="flex min-h-[50vh] items-center justify-center text-muted">
              <Spinner />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <WhatsAppButton />
      <CartDrawer />
    </div>
  );
}
